
import { saveFile } from './file_handler';

var AU = require('ansi_up');
var ansi_up = new AU.default;

var Convert = require('ansi-to-html');


/**
 * @author Raghav Prabhu
 */

/**
 * @param {String} lang Notebook Language (Python, Scala, etc.,)
 * @param {Number} langVersion Language version
 * @param {Array} authors Notebook Authors
 */


function createNotebook (lang, langVersion, authors) {

    if (lang === undefined) {
        lang = ""
    }
    if (langVersion === undefined) {
        langVersion = 0
    }

    var notebook = {};
    var cells = [];
    var languageInfo = {
        "name":lang,
        "version":langVersion

    }
    var metadata = {
        "kernel_info":lang,
        "name" : lang,
        "authors":authors,
        "languageInfo" : languageInfo
    }

   //addNewMarkDownBefore(cells, 0);
   //addNewCodeBefore(cells,0)

   notebook = {
       "metadata":metadata,
       "cells" : cells,
       "nbformat": 4,
       "nbformat_minor": 4
   }

   return notebook; 
}


/**
 * Add empty Code Cell 
 */
 function addEmptyCodeCell() {
    var codeCell = [];

    // Generate a new UUID
    var id = uuidv4();
    var metadata = {
        "decisionforce_cell_id" : id,
        "tags" : [],
    }

    var code = {
        "cell_type" : "code",
        "execution_count": null, 
        "metadata" : metadata,
        "source": "",
        "outputs":[]
    }

    codeCell.push(code);

    var emptyCells = {
        cells : codeCell,
        metadata : metadata,
        "nbformat": 4,
        "nbformat_minor": 4
    }
    return emptyCells;
    }


/**
 * This function will add a new code cell before the current index.
 * 
 * @param {Array} cells Notebook cells array
 * @param {Number} currentIndex Notebook cell current index
 */
function addNewCodeBefore(cells, currentIndex ) {
    var targetIndex = 0;
    if (currentIndex > 0) {
        targetIndex = currentIndex - 1;
    }
    if (cells === undefined) {
        cells = []
    }
    cells.insert(targetIndex, addCodeCell())

    return cells;
}

/**
 * This function will add a new code cell after the current index.
 * 
 * @param {Array} cells Notebook cells array
 * @param {Number} currentIndex Notebook cell current index
 */
function addNewCodeAfter(cells, currentIndex ) {
    var targetIndex = 0;

    // if (currentIndex > 0) {
        targetIndex = currentIndex + 1;
    // }
    if (cells === undefined) {
        cells = []
    }
    cells.insert(targetIndex, addCodeCell())

    return cells;
}

/**
 * This function will add a new markdown cell before the current index.
 * 
 * @param {Array} cells Notebook cells array
 * @param {Number} currentIndex Notebook cell current index
 */
function addNewMarkDownBefore(cells, currentIndex ) {
    var targetIndex = 0;
    if (currentIndex > 0) {
        targetIndex = currentIndex - 1;
    }
    if (cells === undefined) {
        cells = []
    }
    cells.insert(targetIndex, addMarkDownCell())

    return cells;
}

/**
 * This function will add a new markdown cell after the current index.
 * 
 * @param {Array} cells Notebook cells array
 * @param {Number} currentIndex Notebook cell current index
 */
function addNewMarkDownAfter(cells, currentIndex ) {
    var targetIndex = 0;

    // if (currentIndex > 0) {
        targetIndex = currentIndex + 1;
    // }
    if (cells === undefined) {
        cells = []
    }
    cells.insert(targetIndex, addMarkDownCell())
    return cells;
}

/**
 * 
 * @param {Array} cells Notebook cells array move up
 * @param {Number} firstIndex
 * @param {Number} secondIndex 
 */
function moveupCell(cells, firstIndex, secondIndex) {
    cells.swap(firstIndex, secondIndex)
}

/**
 * 
 * @param {Array} cells Notebook cells array move down
 * @param {Number} firstIndex
 * @param {Number} secondIndex 
 */
function movedownCell(cells, firstIndex, secondIndex) {
    cells.swap(firstIndex, secondIndex)
}

function clearCellOutputByIndex(cells, fileProperty, index) {
    if(Array.isArray(cells)) {
        let cellOutput = cells[index].outputs
        if((cellOutput !== undefined) && (Array.isArray(cellOutput)) && (cellOutput.length > 0)) {
            let filePath = undefined;
            let fileType = undefined;
            let metadata = undefined;
            let storageName = undefined;
            let rootFolder = undefined;
            
            if ((fileProperty !== undefined)) {
                filePath = fileProperty.path;
                fileType = fileProperty.type;
                metadata = fileProperty.metadata
                storageName = fileProperty.stName
                rootFolder = fileProperty.rFolder
             }
            cells[index].outputs = [] // Reset outputs array before render
            if((metadata !== undefined) && ((fileType !== undefined)) && (filePath !== undefined)
            && ((storageName !== undefined)) && ((rootFolder !== undefined))
            ) {
                let notebookContent = {
                    cells : cells,
                    metadata : metadata
                  }
                saveFile(filePath, fileType, notebookContent, storageName, rootFolder);
                return cells;
            }
        
        }
 }
}



/**
 * 
 * @param {Array} cells Notebook cells array
 * @param {Number} firstIndex
 * @param {Number} secondIndex 
 */
function removeCell(cells, firstIndex, secondIndex) {
    cells.remove(firstIndex, secondIndex)
}

/**
 * Add New MarkDown Cell
 */
function addMarkDownCell() {
// Generate a new UUID
var id = uuidv4();
var metadata = {
    "decisionforce_cell_id" : id,
    "tags" : []
}
var markdown = {
    "cell_type" : "markdown",
    "metadata" : metadata,
    "source": "##### New Markdown"
}
    return markdown;
}

/**
 * Add New Code Cell
 */
function addCodeCell() {

// Generate a new UUID
var id = uuidv4();
var metadata = {
    "decisionforce_cell_id" : id,
    "tags" : []
}
var code = {
    "cell_type" : "code",
    "execution_count": null, 
    "metadata" : metadata,
    "source": "",
    "outputs":[]
}
    return code;
}

/**
 * Generate new UUID string
 */
function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

/**
 * Insert item in the array by index.
 * 
 * @param {Number} index Array position
 * @param {object} item Array item
 */  
Array.prototype.insert = function ( index, item ) {
    this.splice( index, 0, item );
};

/**
 * 
 * @param {Number} x Array first index
 * @param {Number} y Array second index
 */
Array.prototype.swap = function (x, y) {
    var length = this.length
    if (x >= length || y >= length) {
        return this;
    }
    var b = this[x];
    this[x] = this[y];
    this[y] = b;
    return this;
  }

/**
 * Remove item in the array by index
 * 
 * @param {Number} index Array position 
 */
Array.prototype.remove = function( index )  {
    this.splice(index, 1)
}

/**
 * 
 * @param {Array} data - Output error data array
 */
function renderOutputError(data) {
    var divObj = document.createElement('div');
    divObj.setAttribute("id",uuidv4())
    if (data !== undefined) {
        if(data.traceback !== undefined) {
            data.traceback.forEach(element => {    
                divObj.innerHTML += ansi_up.ansi_to_html(element)  
            });        
        } 
        if (data.text !== undefined) {        
            divObj.innerHTML += ansi_up.ansi_to_html(data.text)
        }
       return divObj.innerHTML;
    }
}

/**
 * Render array of cell outputs
 * 
 * @param {Array} outputData 
 */
function renderOutput(outputData) {
    var divObj = document.createElement('div');
    divObj.setAttribute("id",uuidv4())
    if((outputData !== undefined) && (Array.isArray(outputData))) {
        outputData.forEach(element => {
            divObj.appendChild(renderDisplayData(element))
        });
    }
    return divObj.innerHTML;
}

/**
 * 
 * @param {Array} data - Output data render
 */
function renderDisplayData(data) {
    var divObj = document.createElement('div');
    divObj.setAttribute("className",'displaytxt framediv col-12')
    divObj.setAttribute("id",uuidv4())
    var convert = new Convert();
    if (data !== undefined) {
        var output_type = data.output_type
        if(output_type !== undefined) {
            if(output_type === 'display_data') {
                var imageBase64 = data.data['image/png'];
                var dataTable = data.data['text/html']
                if(imageBase64 !== undefined) {
                    divObj.innerHTML += '<img src="data:image/png;base64,'+imageBase64+'"/>'
                }                
            }
            if(output_type === 'error') {
                var traceback = data.traceback;
                if(traceback !== undefined) {
                    traceback.forEach(element => {    
                        divObj.innerHTML += convert.toHtml(element);
                        divObj.innerHTML += "\n"       
                    });
                }
            }

            if(output_type === 'stream') {
                var stream_type = data.name;
                var streamDivObj = document.createElement('div');
                streamDivObj.setAttribute("id",uuidv4())
                
                if(stream_type === 'stdout') {
                    divObj.setAttribute("className",'displaytxt')  
                } else if(stream_type === 'stderr') {
                    divObj.setAttribute("className",'displaytxt') //TODO: Set Font color to Red
                }
                var data_text = data.text;           
                    if(Array.isArray(data_text)) {
                        data_text.forEach(element => {
                            streamDivObj.innerHTML += ansi_up.ansi_to_html(element)
                        });
                    } 
                divObj.appendChild(streamDivObj) 
            }

        }
        var data_html = data.data;
        if(data_html !== undefined) {
            var dataTable = data_html['text/html']
            if(dataTable !== undefined) {
                divObj.innerHTML += convert.toHtml(dataTable);
            }
        }
    }
    return divObj;
}  
/**
 * Get new date with the format YYYY-mm-ddThh:mm:ss.sssz
 */
function getNewDate() {
    var date = new Date()
	var local = new Date(date);
	local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
	return local.toJSON();
}

/**
 * Generate Notebook cell execution request.
 * 
 * @param {Notebook Cell content} content 
 * @returns request message 
 */
function generateCellRequestMessage(content, metadata, cell_id, connectinId, index, filePath, fileType, isSingleCell) {
    var header = {
        'msg_id' : uuidv4(),
        'decisionforce_cell_id' : cell_id,
        'notebook_metadata' : metadata, 
        'current_index' : index,
        'file_path' : filePath,
        'file_type' : fileType,
        'is_single_cell' : isSingleCell,
        'connectionId':connectinId,
        'date': getNewDate(),
        'msg_type': 'execute_request',
        'version':'5.0'
    }

    var content = {
        'code' : content,
        'silent' : false,
         'store_history' : true
    }

    var message = {
        'header' : header,
        'parent_header' : header,
        'metadata' : {
            'decisionforce_cell_id' : cell_id
        },
        'content' : content
    }

    return message;

}

export { createNotebook, addNewCodeBefore,addEmptyCodeCell, addNewCodeAfter, addNewMarkDownBefore, 
    addNewMarkDownAfter, moveupCell, movedownCell, removeCell, uuidv4, renderOutputError,renderDisplayData, renderOutput, generateCellRequestMessage, clearCellOutputByIndex };
